// Generated by ReScript, PLEASE EDIT WITH CARE


var steppers = {
  hd: {
    label: {
      TAG: /* Text */0,
      _0: "SELECT TEMPLATE"
    },
    subtitle: undefined,
    name: /* SelectTemplate */0
  },
  tl: {
    hd: {
      label: {
        TAG: /* Text */0,
        _0: "SEND MESSAGE"
      },
      subtitle: undefined,
      name: /* TemplateDetails */1
    },
    tl: /* [] */0
  }
};

export {
  steppers ,
  
}
/* No side effect */
